import { UnitTransferEscrowExceptionStatusEnumType } from '__generated__/graphql';

export default function unitTransferEscrowExceptionStatusToReadable(
  status: UnitTransferEscrowExceptionStatusEnumType
): string {
  switch (status) {
    case UnitTransferEscrowExceptionStatusEnumType.Pending:
      return 'Awaiting review';
    // The exception needs a dual sign-off — ops first, then legal. OPS_APPROVED is only half
    // of it, so it must not read as "approved" to the investor.
    case UnitTransferEscrowExceptionStatusEnumType.OpsApproved:
      return 'Approved by operations, awaiting legal';
    case UnitTransferEscrowExceptionStatusEnumType.Approved:
      return 'Approved';
    case UnitTransferEscrowExceptionStatusEnumType.Declined:
      return 'Declined';
    default:
      return status;
  }
}
